module.exports = __webpack_public_path__ + "img/batch-picking.c854a1c6.svg";